import { useMutation } from '@tanstack/react-query';
import { useEffect, useState } from 'react';
import { withNamespaces } from 'react-i18next';
import { toast } from 'react-toastify';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, FormGroup, Label, Input, Spinner } from 'reactstrap';
import RiskAssessmentService from "src/modules/data-protection/apis/RiskAssessmentService";

const AcceptRiskModal = ({ t, isOpen, toggle, riskId, onAccepted }) => {
    const [justification, setJustification] = useState('');

    const handleAcceptRiskMutation = useMutation({
        mutationFn: async (payload) => {
            const service = RiskAssessmentService.getInstance();
            return await service.acceptRisk(riskId, payload)
        },
        onError: () => {
            toast(t('An error occurred while accepting the risk. Please try again later.'), {
                type: 'error'
            })
        },
        onSuccess: () => {
            onAccepted && onAccepted();
            
            toast(t('Risk accepted successfully.'), {
                type: 'success'
            })
        }
    });

    useEffect(() => {
        if (!isOpen) {
            setTimeout(() => {
                setJustification('');
            }, 500);
        }
    }, [ isOpen ]);

    const handleSave = () => {
        handleAcceptRiskMutation.mutate({
            isAccepted: true,
            reason: justification
        });
    };

    return (
        <Modal isOpen={isOpen} toggle={toggle}>
            <ModalHeader toggle={toggle}>
                {t('Accept Risk')}
            </ModalHeader>
            <ModalBody>
                <FormGroup>
                    <Label for="justification">
                        {t('Justification')}
                    </Label>
                    <Input
                        id="justification"
                        type="textarea"
                        value={justification}
                        onChange={(e) => setJustification(e.target.value)}
                        placeholder={`${t('Enter justification for accepting this risk')}...`}
                    />
                </FormGroup>
            </ModalBody>
            <ModalFooter>
                <Button 
                    color="secondary" 
                    onClick={toggle}
                >
                    {t('Cancel')}
                </Button>
                <Button 
                    color="primary" 
                    onClick={handleSave} 
                    disabled={!justification.trim() || handleAcceptRiskMutation.isLoading}
                >
                    {handleAcceptRiskMutation.isLoading && (
                        <Spinner size="sm" color="white" className='me-1' />
                    )}
                    {t('Save')}
                </Button>
            </ModalFooter>
        </Modal>
    );
};

export default withNamespaces()(
    AcceptRiskModal
);
